import { Component } from '@angular/core';

@Component({
  selector: 'app-menu-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './menu-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class MenuIconComponent {}
